export default function SocialProofBar() {
  return (
    <div className="bg-bg-footer py-5 px-6 text-center text-white/50 text-[13px] font-normal tracking-[1px] relative overflow-hidden constellation">
      <div className="relative z-[1]">
        <span className="text-gold-light font-semibold">Award-winning IT trainer</span>
        {' · '}
        <span>CSL Spiritual Leader</span>
        {' · '}
        <span>AI Upskill Mentor</span>
        {' · '}
        <span className="text-gold-light font-semibold">Building since 2021</span>
      </div>
    </div>
  )
}
